import React, { useState } from 'react';
import { Collapse, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const QuoteRules = () => {
  const [open, setOpen] = useState();
  const url_quotes = '/custom_quote_request'

  return (
    <div className="quote-rules">
      <div className="leadtimes-assembly-restrictions">
        <p>
          &nbsp;If you could not get an online price you can request a
          <a href={url_quotes}>
            &nbsp;custom quote.
          </a>
        </p>
        <div className="leadtime-restrictions">
          <div className={`preview-content ${open ? 'expanded' : ''}`}>
            <div>
              <div className="restriction"><h5 className="title">PROTOTYPE PCB ASSEMBLY SERVICE</h5>
                <div className="row">
                  <div className="col-xs-12 col-md-4">
                    <div className="title-leadtime">24 Hour Turn</div>
                    <ul className="m-0">
                      <li>8 PCBs Maximum</li>
                      <li>Up to 15 BOM Line Items</li>
                      <li>Up to 70 SMT placements / board</li>
                      <li>Maximum of 8 Through Hole Components per Order</li>
                    </ul>
                  </div>
                  <div className="col-xs-12 col-md-4">
                    <div className="title-leadtime">48 Hour Turn</div>
                    <ul className="m-0">
                      <li>20 PCBs Maximum</li>
                      <li>Up to 20 BOM Line Items</li>
                      <li>Up to 150 SMT placements / board</li>
                      <li>Maximum of 40 Through Hole Components per Order</li>
                    </ul>
                  </div>
                  <div className="col-xs-12 col-md-4">
                    <div className="title-leadtime">5 Day Turn</div>
                    <ul className="m-0">
                      <li>100 PCBs Maximum</li>
                      <li>Up to 40 BOM Line Items</li>
                      <li>Up to 500 SMT placements / board</li>
                      <li>Maximum of 200 Through Hole Components per Order</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Collapse in={open}>
            <div id="leadtime-collapse-content">
              <div>
                <div className="restriction"><h5 className="title">PROTOTYPE PCB ASSEMBLY SERVICE</h5>
                  <div className="row">
                    <div className="col-xs-12 col-md-4">
                      <div className="title-leadtime">24 Hour Turn</div>
                      <ul className="m-0">
                        <li>8 PCBs Maximum</li>
                        <li>Up to 15 BOM Line Items</li>
                        <li>Up to 70 SMT placements / board</li>
                        <li>Maximum of 8 Through Hole Components per Order</li>
                      </ul>
                    </div>
                    <div className="col-xs-12 col-md-4">
                      <div className="title-leadtime">48 Hour Turn</div>
                      <ul className="m-0">
                        <li>20 PCBs Maximum</li>
                        <li>Up to 20 BOM Line Items</li>
                        <li>Up to 150 SMT placements / board</li>
                        <li>Maximum of 40 Through Hole Components per Order</li>
                      </ul>
                    </div>
                    <div className="col-xs-12 col-md-4">
                      <div className="title-leadtime">5 Day Turn</div>
                      <ul className="m-0">
                        <li>100 PCBs Maximum</li>
                        <li>Up to 40 BOM Line Items</li>
                        <li>Up to 500 SMT placements / board</li>
                        <li>Maximum of 200 Through Hole Components per Order</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="restriction"><h5 className="title">PRODUCTION PCB ASSEMBLY SERVICE</h5>
                  <div className="row">
                    <div className="col-xs-12 col-md-4">
                      <div className="title-leadtime">7 Day Turn</div>
                      <ul>
                        <li>500 PCBs Maximum</li>
                        <li>Up to 70 BOM Line Items</li>
                        <li>Maximum of 500 Through Hole Components per Order</li>
                      </ul>
                    </div>
                    <div className="col-xs-12 col-md-4">
                      <div className="title-leadtime">10 Day Turn</div>
                      <ul>
                        <li>1000 PCBs Maximum</li>
                        <li>Up to 90 BOM Line Items</li>
                        <li>Maximum of 1000 Through Hole Components per Order</li>
                      </ul>
                    </div>
                    <div className="col-xs-12 col-md-4">
                      <div className="title-leadtime">15 Day Turn</div>
                      <ul>
                        <li>4000 PCBs Maximum</li>
                        <li>Up to 120 BOM Line Items</li>
                        <li>Maximum of 4000 Through Hole Components per Order</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Collapse>

          <Button
            variant="outline-secondary"
            size="sm"
            className="btn-toggle mt-2"
            onClick={() => setOpen(!open)}
            aria-controls="leadtime-collapse-content"
            aria-expanded={open}>
            {open ? 'Show Less' : 'Show More'}
            <FontAwesomeIcon className="ms-2" icon={open ? 'caret-up' : 'caret-down'} />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default QuoteRules;
